module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceMask@3x_63eefe.png";